// Fallback parameters of open requests to not block user of sharing their support ticket.
// Tickets with such parameters should be considered as missing info, meaning chatbot flow is missing something.
// We'll ask OPS to report such tickets, so we can consider such flows and update them.
export const FALLBACK_OPEN_REQUEST_SUBJECT = 'Support Request';
export const FALLBACK_OPEN_REQUEST_DESCRIPTION = 'I have an issue with something, please help me.';
export const FALLBACK_OPEN_REQUEST_DESCRIPTION_LENGTH = 3;
